import React from 'react';
import './agilemethod.css'; // Make sure to include the CSS file

function AgileMethod() {
  return (
    <div className='agilemethod-container'>
      <h1 className='agilemethod-heading'>Thrive’s Agile SEO Methodology</h1>
      <h2 className='agilemethod-subheading'>Your First Step Towards Digital Success</h2>
      <p className='agilemethod-body'>
        The search landscape is constantly evolving. To rank high on search engines, you need to invest in the right SEO services tailored to your business’ needs, demands, and target customers. Simply relying on old SEO tactics is not enough to maintain a robust online presence -- you need to find a reliable SEO company that can take your digital marketing efforts up a notch.
        <br /><br />
        Thrive Internet Marketing Agency is a customer-focused SEO company. Our SEO experts work closely with our clients to develop personalized SEO strategies that drive long-term profitability. By using a proven, efficient, and effective methodology, we are able to create high-quality, measurable results.
        <br /><br />
        Our SEO company utilizes a methodology called “Agile SEO,” which allows us to build a robust campaign framework that provides value for your business. Thrive’s Agile SEO approach is built around the following processes:
      </p>
      <img className='agilemethod-image' alt='Agile SEO Methodology' src='../images/agile.png' />
    </div>
  );
}

export default AgileMethod;
